import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.scss';
import Counter from './pages/Counter';
import Layout from './pages/Layout';
import Navigation from './pages/Navigation';
import urljoin from 'url-join';
import { removeTrailingSlash } from './tools/removeTrailingSlash';

const prefix = '/seoyedoum';

const App: React.FC = () => {
  return (
    <Router>
      <Navigation prefix={prefix} />

      {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
      <Switch>
        <Route path={removeTrailingSlash(urljoin(prefix, '/layout'))}>
          <Layout />
        </Route>
        <Route path={removeTrailingSlash(urljoin(prefix, '/'))}>
          <Counter />
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
